// extracted by mini-css-extract-plugin
module.exports = {"buttonsContainer":"OnGoingPaymentBox_buttonsContainer__1mffl","resendInfoText":"OnGoingPaymentBox_resendInfoText__2Rguu"};